export default __webpack_public_path__ + "static/media/reject.9febb85e.svg";